export const BOPISErrors = {
    invalidZipCodeMes: 'Please enter a valid ZIP code.',
    noAvailability:
        'Sorry, no availability at stores within 50 miles. Please enter a new ZIP code.',
    noResults: "Sorry! We can't find any stores within 50 miles of your search.",
    noResultsForCovid19:
        'Sorry, no availability at stores within 50 miles. Please enter a new ZIP code.',
    prePopulateError: 'Error while prepopulating stores',
    somethingWentWrong: 'Sorry, unable to find stores.',
    storesResultsZeroProducts:
        'Sorry! These items are not available at a store within 50 miles of your search.',
};

export const isGalleryURL = '/g/';

export const noSearchResult = {
    findAStore: 'Find a store.',
    noProductsFound: 'Sorry, no products were found matching:',
    searchTips: 'SEARCH TIPS',
    suggestionList: [
        {
            id: 'suggestion-1',
            text: 'Double check your spelling for typos.',
        },
        {
            id: 'suggestion-2',
            text: 'Use general term(s) or fewer keywords.',
        },
        {
            id: 'suggestion-3',
            text: 'Try searching for an item that is less specific and refine results.',
        },
        {
            id: 'suggestion-4',
            text: 'If you are looking for a specific terms from a printed ad.',
        },
        {
            id: 'suggestion-5',
            text: 'Enter the search term or web id as shown.',
        },
    ],
    suggestionWithStoreLink: 'Some product available in store may not be available online.',
    tryNewKeyword: 'Try a new keyword',
};

export const prevNoResultsMessage =
    'The previous results are shown because your last filters produced 0 results.';

export const source = 'rrplacementtype=';
export const url = 'url';
export const allProductsCategory = 'cat1007450013';

/**
 * Constructor facet configuration — mirrors the Java search-service backend config.
 *
 * searchableFiltersMap: facet names that should show a search box when option count > threshold
 * facetTypes: facet name → type mapping (default is 'checkbox')
 */
export const CONSTRUCTOR_FACET_CONFIG = {
    searchableFiltersMap: {
        brand: 13,
        size_range: 13,
        size: 13,
        item_type: 13,
        product_type: 13,
        occasion: 13,
        bed_size: 13,
        sleeve_length: 13,
        features: 13,
        waist: 13,
        dress_length: 13,
        fit: 13,
        stone: 13,
        childrens_sizes: 13,
        age_group: 13,
    },
    facetTypes: {
        color: 'color',
        s1_price_range: 'prange',
        s1_discount_range: 'prange',
        average_rating: 'avgrating',
        top_construction: 'checkboxImage',
        stone: 'image',
        stone_color: 'image',
        stone_cut: 'image',
        warmth_factor: 'checkboxImage',
    },
    defaultFacetType: 'checkbox',
};

/**
 * Default list of system/non-facet URL params that should NOT be sent as
 * filters to Constructor.io search API.
 * All values are lowercase - matching is done case-insensitively.
 *
 * Can be extended/reduced at runtime via preferences config:
 *   preferences.constructorIO.common.ignoreFilterParams = { add: [], remove: [] }
 */
export const CONSTRUCTOR_IGNORE_FILTER_PARAMS = [
    'ppisensemble',
    'cmjcp_t',
    'cmjcp_c',
    'marketing_tiles',
    'utm_medium',
    'cid',
    'utm_source',
    'utm_campaign',
    'utm_content',
    'cjevent',
    'cjdata',
    'debug',
    'mboxdisable',
    'adobe_mc',
    'cm_re',
    'contentdate',
    'usr_seg',
    'usrseg',
    'storeids',
    'id',
    'searchterm',
    'store_availability',
    'page',
    'mkt_tiles',
    'mkttiles',
    'boostids',
    'activefacetid',
    'productgridview',
    'boostus',
    'mode',
    'sort',
    'searchtype',
    'predsearchterm',
    'redirectterm',
    '_br_uid_2',
    'previewdate',
    'item_status',
    'channel',
    'responsetype',
    'pagetype',
    'dr',
    'ntt',
    'enablequeryprofile',
    'onerecid',
    'selectedlotid',
    'selectedskuid',
    'regionid',
    'disablener',
    'disableesp',
    'disableautoscope',
    'n',
    'ltrqueryenabled',
    'disableltr',
    'extractadditionalfields',
    'incfacet',
    'hierarchyfacet',
    'excfval',
    'scrollto',
    'predictivedetail',
    'term',
    'nvalue',
    'numproducts',
    'recentpp',
    'atgdevid',
    'addmsg',
    'removecolorfilter',
    'userzoneid',
    'geolocstoreid',
    'geolocstoreiddebug',
    'pageid',
    'version_cd',
    'cm_lm',
    'mi_u',
    'fcap',
    'targetqa',
    'utm_adgroupid',
    'utm_device',
    'utm_keyword',
    'utm_matchtype',
    'sfmc_sub',
    'gclid',
    'gclsrc',
    'afsrc',
    'fbclid',
    'gbraid',
    'degp_ladder_id',
    'degp_segment_id',
    'msclkid',
    'wbraids',
    'geozip',
    'dpakamaioverride',
    'gad_source',
    'gad_campaignid',
    'utm_term',
    'utm_id',
    'clickid',
    'nf',
    // Additional tracking/marketing params
    'ttclid',
    'utm_channel',
    'attn_lid',
    'xid',
    'externalid',
    'sitecode',
    'epik',
    'pp',
    'olref',
    'oppref',
    'attn_macro',
    'attn_pos',
    'dclid',
    'eps',
    'scrlybrkr',
    'gb',
    'gref',
    'j',
    'jb',
    'mid',
    'msockid',
    'rdt_cid',
    'referrer',
    'u',
    'bccouponsource',
    'attn_sid',
    'attn_idx',
    'a',
    'clientid',
    'utm_rcs',
    'email',
    'hashedemail',
];

/**
 * Preview key where fields are stored
 */
export const PREVIEWABLE_FIELDS_KEY = 'pf';

/**
 * URL params that should be preserved (passed through) in facet/filter/sort URLs.
 * These params are not sent to Constructor API but should remain in browser URLs
 * when users click on filters so they are maintained during navigation.
 *
 * Passthrough params are determined dynamically: any URL param that is NOT in
 * CONSTRUCTOR_IGNORE_FILTER_PARAMS and is NOT a recognized facet/filter param
 * will be automatically passed through. This allows unknown/custom params to
 * be preserved without requiring explicit configuration.
 */

export const SORT_KEYS = {
    PRICE_LOW_HIGH: 'LPLH',
    PRICE_HIGH_LOW: 'LPHL',
    BEST_MATCH: 'BM',
    FEATURED: 'FS',
    NEW_ARRIVALS: 'NA',
    TOP_RATED: 'TR',
    POPULARITY: 'P',
};
export const PRICING_SORT_VALUES = {
    PRICE_LOW_HIGH: ['LPLH', 'PLH', 'PLHS'],
    PRICE_HIGH_LOW: ['LPHL', 'PHL', 'PHLS'],
};

export const MONTH_ABBR = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
